import {
  Table as MantineTable,
  TableTrProps,
  TableTdProps,
} from '@mantine/core'
import { ReactNode } from 'react'
import { ColumnProps } from '../table.types'
import styled from 'styled-components'

export const StyledTableRow = styled(MantineTable.Tr)<{
  $isClickable: boolean
}>`
  ${({ theme }) => `
    border-bottom: 1px solid ${theme.colors.gray80};
    padding: 16px 0;
  `}

  ${(p) =>
    p.$isClickable &&
    `
    cursor:pointer;  
    transition: background-color 0.1s ease-in-out;

    &:focus {
      outline: none;
      background-color: ${p.theme.colors.gray70};
    }

    &:hover {
      background-color: ${p.theme.colors.gray70};
    }
  `}
`

export function TableBody({ children }: { children: ReactNode }) {
  return <MantineTable.Tbody>{children}</MantineTable.Tbody>
}

export function TableRow({ children, onClick, ...props }: TableTrProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTableRowElement>) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault()
      onClick({} as React.MouseEvent<HTMLTableRowElement>)
    }
  }

  return (
    <StyledTableRow
      onClick={onClick}
      $isClickable={!!onClick}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
      {...props}
    >
      {children}
    </StyledTableRow>
  )
}

export const StyledTableCell = styled(MantineTable.Td)`
  ${({ theme }) => `
    color: black;
    font-size: ${theme.fontSizes.bodySmall};
    padding: 14px 8px;

    &:first-child {
      padding-left: 16px;
    }

    &:last-child {
      padding-right: 16px;
    }
  `}
`

export function TableCell({
  children,
  inlineStyle,
  className,
  dataTestId,
  onClick,
  ...props
}: TableTdProps & {
  inlineStyle?: ColumnProps
  dataTestId?: string
}) {
  return (
    <StyledTableCell
      style={inlineStyle}
      className={className}
      data-testid={dataTestId}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledTableCell>
  )
}
